<template>
  <div>
    <el-dialog
      custom-class="recipientcustomClass"
      title="选择收件人"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="false"
    >
      <el-row class="searcRow">
        <el-col :span="12" class="serchCol">可选择的收件人{{ '('+totalNum+')' }}</el-col>
        <el-col :span="12">
          <el-input
            placeholder="客户名称，联系人姓名/邮箱"
            clearable
            v-model="keyword"
            :maxlength="500"
            size="small"
            :suffix-icon="keyword?'':'el-icon-search'"
            @keydown.enter.native="searchData"
            @clear="getQueryRecipient"
          ></el-input>
        </el-col>
      </el-row>
      <div>
        <el-table
          height="286px"
          v-el-table-infinite-scroll="loadMoreData"
          :data="tableData"
          style="width: 100%"
          @current-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column prop="contactName" label="联系人" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="companyName">
                {{scope.row.contactName|noText}}    
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="titleStr" label="职务" width="180" >
            <template slot-scope="scope">
              <div >
                {{scope.row.titleStr|noText}}    
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="邮箱" >
            <template slot-scope="scope">
              <div >
                {{scope.row.email|noText}}    
              </div>
            </template>  
          </el-table-column>
          <el-table-column prop="companyName" label="客户名称" show-overflow-tooltip > 
            <template slot-scope="scope">
              <div class="companyName">
                {{scope.row.companyName|noText}}    
              </div>
            </template> 
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="chooseDiv">已选 <span>{{contactIds.length}}</span> 个收件人</div>
        <div class="tagDiv">
          <!-- :contenteditable="contactIds.length>0?'true':'false'" -->
          <el-tag
            class="tagList"
            type="info"
            v-for="tag in contactIds"
            :key="tag.id"
            closable
            @close="handleClosetag(tag)"
          >
            {{ tag.contactName }} &lt;{{ tag.email }}&gt;
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="determine"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import elTableInfiniteScroll from "el-table-infinite-scroll";
import {queryRecipient} from "@/utils/api/edmSubject"
export default {
  directives: {
    "el-table-infinite-scroll": elTableInfiniteScroll,
  },
  data() {
    return {
      dialogVisible: false,
      loading:false,
      keyword: "",
      curPage:1,
      totalNum:0,
      tableData: [],
      contactIds: []
    };
  },
  mounted(){
    // this.getQueryRecipient()
    // this.contactIds=this.contactIdsArr
  },
  methods: {
    // 获取数据
    async getQueryRecipient(){
      this.loading=true
      let params={
        "keyword": this.keyword.trim(),
        "curPage": this.curPage,
        "pageSize": 50,
        "attribute": "",
        "sortType": 0
      }
      const res= await queryRecipient(params)
      if(res.rspResult.bizCode==200){
        this.tableData=this.tableData.concat(res.rspPageData.list)
        this.totalNum=res.rspPageData.totalNum
        this.loading=false
      }
    },
    // 获取选中数据
    getcontactIds(val){
      this.contactIds=JSON.parse(JSON.stringify(val))
    },
    handleClose(done) {
      // this.$confirm("确认关闭？")
      //   .then((_) => {
          done();
        // })
        // .catch((_) => {});
    },
    handleClosetag(tag) {
      // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.contactIds.forEach((value,index,array)=>{
        if(value.id == tag.id){
          array.splice(index,1)
        }
      })
    },
    loadMoreData() {
      // console.log(999999999);
      if(!this.loading){
        this.curPage+=1
        this.getQueryRecipient()
      }
     
      // this.tableData += this.tableData.concat(this.tableData)
    },
    async searchData(e) {
      if (e.keyCode == 13) {
        this.curPage=1
        this.tableData=[]
        this.getQueryRecipient()
      }
    },
    handleSelectionChange(val) {
      if(this.contactIds.length==0){
        this.contactIds.push(val)
      }else{
        var flag = this.contactIds.findIndex(item => item.id=== val.id)
        if(flag<0){
          this.contactIds.push(val)
        }
      }
    },
    determine(){
      console.log(this.contactIds)
      this.$emit('determineSelect',this.contactIds)
      this.dialogVisible = false
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .recipientcustomClass {
  width: 760px;
  // height: 654px;
  .el-dialog__body {
    padding: 10px 20px;
  }
      /**修改全局的滚动条*/
    /**滚动条的宽度*/
    ::-webkit-scrollbar {
      width: 6px;
      scrollbar-width: 6px;
    }
    // 滚动条的滑块
    ::-webkit-scrollbar-thumb {
      background-color: rgba(144,147,153,.3);
      border-radius: 3px;
      scrollbar-color: rgba(144,147,153,.3);
    }
    scrollbar-width: thin;//滚动条变细，为none时隐藏滚动条
  // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
}
.chooseDiv {
  margin-top: 24px;
  margin-bottom: 14px;
  color: #16181aff;
  font-size: 14px;
  span {
    color: #e6a23c;
  }
}

.tagDiv {
  height: 68px;
  border: 1px solid #cfd5df;
  border-radius: 2px;
  padding: 14px;
  overflow: auto;
  .tagList {
    margin-right: 8px;
    margin-bottom: 8px;
    color: #16181aff;
  }
}
.searcRow {
  margin-bottom: 12px;
  .serchCol {
    line-height: 32px;
    color: #16181A;
  }
}
.companyName{
  overflow: hidden;
  text-overflow: ellipsis
}
</style>